<template>
  <FriendlierCard>
    <div class="padded-block">
      <div class="logo">
        <LocaleAwareLogo variant="primary" color="ocean" />
      </div>
      <!-- <h2 class="is-size-2 mb-4 mt-2 title">Login</h2> -->
      <h2 class="is-size-2 mb-4 mt-2 title">{{ $t("loginVue.login") }}</h2>
      <form>
        <div class="friendlier-field">
          <p class="control">
            <span class="icon is-medium is-left mr-3">
              <FontAwesomeIcon icon="envelope" />
            </span>
            <input 
              id="login-email"
              name="email"
              type="email" 
              required 
              :placeholder="$t('loginVue.email')" 
              v-model="email" 
              autocomplete="email"
              inputmode="email"
              autocapitalize="off"
              spellcheck="false"
              @input="handleEmailInput"
              @blur="handleEmailBlur"
              class="is-size-4 is-right p-2" />
          </p>
          <p v-if="emailSuggestion" class="email-suggestion">
            Did you mean
            <button type="button" class="email-suggestion-link" @click="applyEmailSuggestion">{{ emailSuggestion }}</button>?
          </p>
        </div>
        <div class="friendlier-field">
          <p class="control">
            <span class="icon is-medium is-left mr-3">
              <FontAwesomeIcon icon="key" class="fas" />
            </span>
            <input
              :type="showPassword ? 'text' : 'password'"
              required
              :placeholder="$t('loginVue.password')"
              v-model="password"
              class="is-size-4 is-right p-2 password-input"
            />
            <span @click="toggleVisibility" class="password-icon"> <!-- add a span with eye icon that will call toggleVisibility @click-->
              <FontAwesomeIcon :icon="showPassword ? 'eye' : 'eye-slash'" />
            </span>
          </p>
        </div>

        <button @click.prevent="login" class="ocean-button mt-3 is-bold fs-1-2">
          {{ $t("loginVue.log-in") }}
        </button>
        <div class="mt-3 has-text-danger">{{ errorMessage }}</div>
      </form>
      <p class="mt-3">
        <span :onclick="forgot">
          <a class="is-cloud">{{ $t("loginVue.forgot-password") }}</a>
        </span>
      </p>
      <hr class="is-back-cloud" />
      <p class="has-text-weight-light mb-2 is-cloud">
        {{ $t("loginVue.no-account") }}
      </p>
      <span class="ocean-button is-bold fs-1-2" :onclick="signup">
        {{ $t("loginVue.sign-up") }}
      </span>
      <div class="locale-switcher">
        <LocaleSwitcher />
      </div>
    </div>
  </FriendlierCard>
</template>

<script>
import LocaleSwitcher from "@/components/LocaleSwitcher";
import { ref, computed } from "vue";
import { useFirebase } from "@/revamp/composables";
import { FriendlierCard, LocaleAwareLogo } from "@/revamp/components";
import { useRouter } from "vue-router";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { getSuggestedEmail } from "@/revamp/utils";

import { useI18n } from "vue-i18n";

export default {
  name: "Login",
  components: {
    FriendlierCard,
    LocaleSwitcher,
    LocaleAwareLogo,
    FontAwesomeIcon,
  },
  props: {
    signup: Function,
    forgot: Function,
  },
  setup() {
    const errorMessage = ref("");
    const email = ref("");
    const emailSuggestion = ref(null);
    const password = ref("");
    const APIService = useFirebase();
    const Router = useRouter();
    const showPassword = ref(false); //default to hiding

    const { t } = useI18n({
      locale: "en",
      messages: {
        en: {
          invalid: "Invalid email or password",
        },
        fr: {
          invalid: "Mot de passe ou courriel invalide",
        },
      },
    });

    function toggleVisibility() {
      showPassword.value = !showPassword.value;
    }

    function handleEmailInput() {
      emailSuggestion.value = null;
    }

    function handleEmailBlur() {
      emailSuggestion.value = getSuggestedEmail(email.value);
    }

    function applyEmailSuggestion() {
      if (!emailSuggestion.value) return;
      email.value = emailSuggestion.value;
      emailSuggestion.value = null;
    }

    const msg = computed(() => t("invalid"));

    async function login() {
      if (email.value == "" || password.value == "") {
        //errorMessage.value = this.$t('loginVue.err-enter');
        //errorMessage.value = i18n.t('err-enter');
        errorMessage.value = t("invalid");

        return;
      }
      email.value = email.value.toLowerCase().trim();
      emailSuggestion.value = null;
      try {
        await APIService.login(email.value, password.value);
        const redirect = Router.currentRoute.value.query?.redirect;
        const redirectPath = Array.isArray(redirect) ? redirect[0] : redirect;

        if (typeof redirectPath === "string" && redirectPath.startsWith("/") && !redirectPath.startsWith("//")) {
          Router.push(redirectPath);
        } else {
          Router.push({ name: "Dashboard" });
        }
      } catch (e) {
        //errorMessage.value = $t('loginVue.err-invalid');
        errorMessage.value = t("invalid");
        //errorMessage.value = i18n.t('err-invalid');
      }
    }

    return {
      // Data
      errorMessage,
      password,
      email,
      emailSuggestion,
      showPassword,
      // Methods
      login,
      toggleVisibility,
      handleEmailInput,
      handleEmailBlur,
      applyEmailSuggestion,

      t,
      msg,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/revamp/assets/scss/colors.scss";
@import "@/revamp/assets/scss/elements.scss";

.padded-block {
  padding: 20px;
  width: 100%;
  text-align: center;
}

.title {
  color: $sunflower;
}

.logo {
  max-width: 30%;
  min-width: 300px;
  margin: 0 auto;
}

.dropdown {
  outline: pink;
  background-color: pink;
  // appearance: none;
  // color: #4a4a4a;
  color: red;
  font-size: 1.25rem !important;
  // padding: 0.5rem 0.75rem;
  padding-top: 0.5rem;
  // padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
}

.password-icon {
  position: absolute;
  right: 0.75rem; //0.75rem away from right 
  top: 50%; 
  transform: translateY(-50%); //this and top will center it vertically
  color: #f0ba30; //from main.scss
  cursor: pointer; //indicate clickable
}

.friendlier-field input {
  width: 100%; //email and password are both friendlier-field inputs so to keep them the same length just make their width 100% explicitly
  box-sizing: border-box; //makes it so that when its calculating width it includes padding
}

.password-input {
  padding-right: 3rem !important; //this adds padding only to the password input
}

.email-suggestion {
  margin-top: 0.5rem;
  color: #4a4a4a;
  font-size: 0.95rem;
}

.email-suggestion-link {
  appearance: none;
  border: none;
  background: none;
  color: #0048b4;
  font: inherit;
  padding: 0;
  text-decoration: underline;
  cursor: pointer;
}

</style>